export const iconFontAwesomeMedicalHealthTablets = (
	<i className="fa-solid fa-tablets"></i>
);
